// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-table-modal .modal-content {
  border-radius: 24px;
  overflow: hidden;
  box-shadow:
    0 32px 64px rgba(0, 0, 0, 0.4),
    0 16px 32px rgba(0, 0, 0, 0.3),
    0 8px 16px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.08);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
}

.modal-header-custom {
  background:
    radial-gradient(1200px 600px at -10% -10%, rgba(124, 58, 237, 0.25), transparent 60%),
    linear-gradient(180deg, #1f2937 0%, #111827 100%);
  padding: 2rem 2.5rem;
  border-bottom: 1px solid #374151;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.table-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: #374151;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  color: #9ca3af;
  border: 1px solid #4b5563;
}

.header-text {
  color: white;
}

.table-title {
  font-size: 1.75rem;
  font-weight: 800;
  margin-bottom: 0.75rem;
  color: white;
  letter-spacing: -0.025em;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.table-badges {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
}

.info-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #374151;
  padding: 0.5rem 1rem;
  border-radius: 16px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #d1d5db;
  border: 1px solid #4b5563;
}

.info-badge.status-running {
  background: rgba(16, 185, 129, 0.12);
  color: #34d399;
  border-color: rgba(16, 185, 129, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: 0 8px 14px rgba(16, 185, 129, 0.15);
}

.info-badge.status-stopped {
  background: rgba(239, 68, 68, 0.14);
  color: #f87171;
  border-color: rgba(239, 68, 68, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: 0 8px 16px rgba(239, 68, 68, 0.18);
}

.info-badge.status-unknown {
  background: rgba(107, 114, 128, 0.2);
  color: #e5e7eb;
  border-color: rgba(107, 114, 128, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.table-id-badge,
.table-url-badge {
  font-family: 'JetBrains Mono', 'Courier New', monospace;
  font-size: 0.75rem;
  max-width: none;
  word-break: break-all;
}

.copy-id-button {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 0.25rem;
  color: #cbd5e1;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  margin-left: 0.5rem;
}

.copy-id-button:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  transform: scale(1.05);
}

/* Active/Inactive state badge */
.state-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.9rem;
  border-radius: 999px;
  font-weight: 700;
  letter-spacing: 0.02em;
  border: 1px solid transparent;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.state-badge.active {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
  border-color: rgba(16, 185, 129, 0.35);
}

.state-badge.inactive {
  background: rgba(107, 114, 128, 0.15);
  color: #cbd5e1;
  border-color: rgba(107, 114, 128, 0.35);
}

.close-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  cursor: pointer;
}

.close-button:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

.table-section {
  padding: 2rem 2.5rem;
  background: linear-gradient(180deg, #111827 0%, #0b1220 100%);
  border-bottom: 1px solid #374151;
}

.players-table-container {
  max-width: 100%;
}

.players-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 1.5rem 0;
  letter-spacing: -0.025em;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.players-title i {
  color: #cbd5e1;
}

.players-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 0.75rem;
  gap: 0.75rem;
}

.player-card {
  background: linear-gradient(180deg, rgba(31, 41, 55, 0.9), rgba(17, 24, 39, 0.9));
  border: 1px solid #2b3545;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;
}

.player-card:hover {
  background: linear-gradient(180deg, rgba(55, 65, 81, 0.95), rgba(31, 41, 55, 0.95));
  border-color: #4b5563;
}

.player-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.player-seat {
  font-size: 0.75rem;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.player-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: #ffffff;
}

.player-stack {
  font-size: 0.8rem;
  font-weight: 700;
  color: #22c55e;
  background: rgba(34, 197, 94, 0.15);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  border: 1px solid rgba(34, 197, 94, 0.3);
  text-align: center;
  white-space: nowrap;
}

.no-players {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 2rem;
  color: #94a3b8;
  font-size: 0.875rem;
}

.no-players i {
  font-size: 2rem;
  opacity: 0.5;
}

.events-section {
  padding: 2rem 2.5rem;
  background: linear-gradient(180deg, #162033, #0e1627);
}

.events-header-toggle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(99, 102, 241, 0.08);
  border: 1px solid rgba(99, 102, 241, 0.2);
  border-radius: 16px;
  padding: 1rem 1.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #e2e8f0;
  text-align: left;
  font: inherit;
}

.events-header-toggle:hover {
  border-color: rgba(99, 102, 241, 0.4);
  box-shadow: 0 10px 25px rgba(99, 102, 241, 0.15);
}

.events-header-toggle:focus-visible {
  outline: 2px solid rgba(99, 102, 241, 0.6);
  outline-offset: 2px;
}

.events-title-group {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.chevron {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(148, 163, 184, 0.12);
  color: #94a3b8;
  font-size: 1.25rem;
  transition:
    transform 0.2s ease,
    background 0.2s ease;
}

.events-header-toggle:hover .chevron {
  background: rgba(99, 102, 241, 0.2);
  color: #c7d2fe;
}

.chevron.open {
  transform: rotate(180deg);
}

.events-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  letter-spacing: -0.025em;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.events-title i {
  color: #cbd5e1;
}

.events-count {
  background: #6366f1;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 16px;
  font-size: 0.875rem;
  font-weight: 700;
  transition: transform 0.2s ease;
}

.events-header-toggle:hover .events-count {
  transform: translateX(4px);
}

.events-table-container {
  margin-top: 1.5rem;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 16px;
  border: 1px solid #2a3344;
  background: linear-gradient(180deg, #0b1220, #0b1220);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
}

/* Override DataTable styles for consistent theming */
.events-table-container .table {
  background: transparent;
  margin: 0;
}

.events-table-container .table thead th {
  background: linear-gradient(180deg, #243041, #1b2534);
  border-bottom: 2px solid #2e3a4d;
  color: #ffffff;
  font-weight: 700;
  font-size: 0.875rem;
  padding: 1rem 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.events-table-container .table tbody tr {
  border-bottom: 1px solid #374151;
  transition: background-color 0.2s ease;
}

.events-table-container .table tbody tr:hover {
  background: rgba(255, 255, 255, 0.04);
}

.events-table-container .table tbody tr:last-child {
  border-bottom: none;
}

.events-table-container .table tbody td {
  padding: 1rem 0.75rem;
  vertical-align: middle;
  background: transparent;
  border: none;
  color: #e2e8f0;
}

.event-number {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #6366f1;
  color: white;
  font-size: 0.8rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.event-badge {
  padding: 0.5rem 0.875rem;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: capitalize;
  border: 1px solid;
  display: inline-block;
}

.event-badge-success {
  background: #f0fdf4;
  color: #166534;
  border-color: #bbf7d0;
}

.event-badge-danger {
  background: #fef2f2;
  color: #dc2626;
  border-color: #fecaca;
}

.event-badge-warning {
  background: #fffbeb;
  color: #d97706;
  border-color: #fed7aa;
}

.event-badge-info {
  background: #faf5ff;
  color: #7c3aed;
  border-color: #d8b4fe;
}

.timestamp-cell {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.timestamp-cell .time {
  font-weight: 700;
  font-size: 0.9rem;
  color: #ffffff;
}

.timestamp-cell .date {
  font-size: 0.8rem;
  color: #cbd5e1;
  font-weight: 500;
}

.message-cell {
  word-wrap: break-word;
  word-break: break-word;
  color: #e2e8f0;
  font-size: 0.9rem;
  line-height: 1.5;
  font-weight: 500;
  white-space: normal;
}

.copy-button {
  padding: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  background: rgba(30, 41, 59, 0.8);
  color: #cbd5e1;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.copy-button:hover {
  background: #4b5563;
  color: #ffffff;
  border-color: #6b7280;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-header-custom {
    padding: 1rem;
  }

  .header-info {
    gap: 0.75rem;
  }

  .table-icon {
    width: 40px;
    height: 40px;
    font-size: 1.25rem;
  }

  .table-title {
    font-size: 1.25rem;
  }

  .table-badges {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }

  .table-id-inline {
    order: -1;
    margin-bottom: 0.5rem;
  }

  .table-section {
    padding: 1rem;
  }

  .events-section {
    padding: 1rem;
  }

  .events-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .events-table-container .table thead th,
  .events-table-container .table tbody td {
    padding: 0.75rem 0.5rem;
    font-size: 0.8rem;
  }

  .message-cell {
    max-width: 200px;
    font-size: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/tournaments/TournamentDetails/components/TournamentTableDetailsModal.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB;;;;0CAIwC;EACxC,2CAA2C;EAC3C,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE;;qDAEmD;EACnD,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;EACrC,yBAAyB;EACzB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,uCAAuC;EACvC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,uDAAuD;EACvD,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,mDAAmD;AACrD;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,iFAAiF;EACjF,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mFAAmF;EACnF,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB;;wBAEsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA,qDAAqD;AACrD;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;;IAEE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".tournament-table-modal .modal-content {\n  border-radius: 24px;\n  overflow: hidden;\n  box-shadow:\n    0 32px 64px rgba(0, 0, 0, 0.4),\n    0 16px 32px rgba(0, 0, 0, 0.3),\n    0 8px 16px rgba(0, 0, 0, 0.2),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(20px);\n}\n\n.modal-header-custom {\n  background:\n    radial-gradient(1200px 600px at -10% -10%, rgba(124, 58, 237, 0.25), transparent 60%),\n    linear-gradient(180deg, #1f2937 0%, #111827 100%);\n  padding: 2rem 2.5rem;\n  border-bottom: 1px solid #374151;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.table-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 16px;\n  background: #374151;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.75rem;\n  color: #9ca3af;\n  border: 1px solid #4b5563;\n}\n\n.header-text {\n  color: white;\n}\n\n.table-title {\n  font-size: 1.75rem;\n  font-weight: 800;\n  margin-bottom: 0.75rem;\n  color: white;\n  letter-spacing: -0.025em;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.table-badges {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.info-badge {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #374151;\n  padding: 0.5rem 1rem;\n  border-radius: 16px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #d1d5db;\n  border: 1px solid #4b5563;\n}\n\n.info-badge.status-running {\n  background: rgba(16, 185, 129, 0.12);\n  color: #34d399;\n  border-color: rgba(16, 185, 129, 0.35);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  box-shadow: 0 8px 14px rgba(16, 185, 129, 0.15);\n}\n\n.info-badge.status-stopped {\n  background: rgba(239, 68, 68, 0.14);\n  color: #f87171;\n  border-color: rgba(239, 68, 68, 0.35);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  box-shadow: 0 8px 16px rgba(239, 68, 68, 0.18);\n}\n\n.info-badge.status-unknown {\n  background: rgba(107, 114, 128, 0.2);\n  color: #e5e7eb;\n  border-color: rgba(107, 114, 128, 0.35);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.table-id-badge,\n.table-url-badge {\n  font-family: 'JetBrains Mono', 'Courier New', monospace;\n  font-size: 0.75rem;\n  max-width: none;\n  word-break: break-all;\n}\n\n.copy-id-button {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  padding: 0.25rem;\n  color: #cbd5e1;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  margin-left: 0.5rem;\n}\n\n.copy-id-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  transform: scale(1.05);\n}\n\n/* Active/Inactive state badge */\n.state-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.45rem 0.9rem;\n  border-radius: 999px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  border: 1px solid transparent;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);\n}\n\n.state-badge.active {\n  background: rgba(16, 185, 129, 0.1);\n  color: #10b981;\n  border-color: rgba(16, 185, 129, 0.35);\n}\n\n.state-badge.inactive {\n  background: rgba(107, 114, 128, 0.15);\n  color: #cbd5e1;\n  border-color: rgba(107, 114, 128, 0.35);\n}\n\n.close-button {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: white;\n  font-size: 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.close-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: scale(1.05);\n}\n\n.table-section {\n  padding: 2rem 2.5rem;\n  background: linear-gradient(180deg, #111827 0%, #0b1220 100%);\n  border-bottom: 1px solid #374151;\n}\n\n.players-table-container {\n  max-width: 100%;\n}\n\n.players-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 1.5rem 0;\n  letter-spacing: -0.025em;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.players-title i {\n  color: #cbd5e1;\n}\n\n.players-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 0.75rem;\n}\n\n.player-card {\n  background: linear-gradient(180deg, rgba(31, 41, 55, 0.9), rgba(17, 24, 39, 0.9));\n  border: 1px solid #2b3545;\n  border-radius: 12px;\n  padding: 1rem 1.25rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.2s ease;\n}\n\n.player-card:hover {\n  background: linear-gradient(180deg, rgba(55, 65, 81, 0.95), rgba(31, 41, 55, 0.95));\n  border-color: #4b5563;\n}\n\n.player-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.player-seat {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.player-name {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.player-stack {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #22c55e;\n  background: rgba(34, 197, 94, 0.15);\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  text-align: center;\n  white-space: nowrap;\n}\n\n.no-players {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 2rem;\n  color: #94a3b8;\n  font-size: 0.875rem;\n}\n\n.no-players i {\n  font-size: 2rem;\n  opacity: 0.5;\n}\n\n.events-section {\n  padding: 2rem 2.5rem;\n  background: linear-gradient(180deg, #162033, #0e1627);\n}\n\n.events-header-toggle {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(99, 102, 241, 0.08);\n  border: 1px solid rgba(99, 102, 241, 0.2);\n  border-radius: 16px;\n  padding: 1rem 1.25rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #e2e8f0;\n  text-align: left;\n  font: inherit;\n}\n\n.events-header-toggle:hover {\n  border-color: rgba(99, 102, 241, 0.4);\n  box-shadow: 0 10px 25px rgba(99, 102, 241, 0.15);\n}\n\n.events-header-toggle:focus-visible {\n  outline: 2px solid rgba(99, 102, 241, 0.6);\n  outline-offset: 2px;\n}\n\n.events-title-group {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.chevron {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(148, 163, 184, 0.12);\n  color: #94a3b8;\n  font-size: 1.25rem;\n  transition:\n    transform 0.2s ease,\n    background 0.2s ease;\n}\n\n.events-header-toggle:hover .chevron {\n  background: rgba(99, 102, 241, 0.2);\n  color: #c7d2fe;\n}\n\n.chevron.open {\n  transform: rotate(180deg);\n}\n\n.events-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n  letter-spacing: -0.025em;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.events-title i {\n  color: #cbd5e1;\n}\n\n.events-count {\n  background: #6366f1;\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 16px;\n  font-size: 0.875rem;\n  font-weight: 700;\n  transition: transform 0.2s ease;\n}\n\n.events-header-toggle:hover .events-count {\n  transform: translateX(4px);\n}\n\n.events-table-container {\n  margin-top: 1.5rem;\n  max-height: 400px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  border-radius: 16px;\n  border: 1px solid #2a3344;\n  background: linear-gradient(180deg, #0b1220, #0b1220);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);\n}\n\n/* Override DataTable styles for consistent theming */\n.events-table-container .table {\n  background: transparent;\n  margin: 0;\n}\n\n.events-table-container .table thead th {\n  background: linear-gradient(180deg, #243041, #1b2534);\n  border-bottom: 2px solid #2e3a4d;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 0.875rem;\n  padding: 1rem 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.events-table-container .table tbody tr {\n  border-bottom: 1px solid #374151;\n  transition: background-color 0.2s ease;\n}\n\n.events-table-container .table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.events-table-container .table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.events-table-container .table tbody td {\n  padding: 1rem 0.75rem;\n  vertical-align: middle;\n  background: transparent;\n  border: none;\n  color: #e2e8f0;\n}\n\n.event-number {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #6366f1;\n  color: white;\n  font-size: 0.8rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.event-badge {\n  padding: 0.5rem 0.875rem;\n  border-radius: 8px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: capitalize;\n  border: 1px solid;\n  display: inline-block;\n}\n\n.event-badge-success {\n  background: #f0fdf4;\n  color: #166534;\n  border-color: #bbf7d0;\n}\n\n.event-badge-danger {\n  background: #fef2f2;\n  color: #dc2626;\n  border-color: #fecaca;\n}\n\n.event-badge-warning {\n  background: #fffbeb;\n  color: #d97706;\n  border-color: #fed7aa;\n}\n\n.event-badge-info {\n  background: #faf5ff;\n  color: #7c3aed;\n  border-color: #d8b4fe;\n}\n\n.timestamp-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.timestamp-cell .time {\n  font-weight: 700;\n  font-size: 0.9rem;\n  color: #ffffff;\n}\n\n.timestamp-cell .date {\n  font-size: 0.8rem;\n  color: #cbd5e1;\n  font-weight: 500;\n}\n\n.message-cell {\n  word-wrap: break-word;\n  word-break: break-word;\n  color: #e2e8f0;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  font-weight: 500;\n  white-space: normal;\n}\n\n.copy-button {\n  padding: 0.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  background: rgba(30, 41, 59, 0.8);\n  color: #cbd5e1;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.9rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.copy-button:hover {\n  background: #4b5563;\n  color: #ffffff;\n  border-color: #6b7280;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .modal-header-custom {\n    padding: 1rem;\n  }\n\n  .header-info {\n    gap: 0.75rem;\n  }\n\n  .table-icon {\n    width: 40px;\n    height: 40px;\n    font-size: 1.25rem;\n  }\n\n  .table-title {\n    font-size: 1.25rem;\n  }\n\n  .table-badges {\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: flex-start;\n  }\n\n  .table-id-inline {\n    order: -1;\n    margin-bottom: 0.5rem;\n  }\n\n  .table-section {\n    padding: 1rem;\n  }\n\n  .events-section {\n    padding: 1rem;\n  }\n\n  .events-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .events-table-container .table thead th,\n  .events-table-container .table tbody td {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.8rem;\n  }\n\n  .message-cell {\n    max-width: 200px;\n    font-size: 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
